// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"04bc2bf4","389":"8744399d","453":"395b8ace","732":"80bc9953","977":"d59ef577"}[chunkId] + ".chunk.js";
};